export default __webpack_public_path__ + "static/media/KAB-token.e83127a0.png";